"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { useResponsiveDrawerDirection } from "./useResponsiveDrawerDirection.js";
const DEFAULT_SNAP_POINTS = [
    0.5,
    1
];
function DrawerRoot({ snapPoints = DEFAULT_SNAP_POINTS, modal = false, disablePointerDismissal = true, swipeDirection, ...props }) {
    const horizonDir = 'left' === swipeDirection || 'right' === swipeDirection ? swipeDirection : void 0;
    const effectiveHorizonDir = useResponsiveDrawerDirection(horizonDir, null);
    const effectiveSwipeDirection = 'bottom' === effectiveHorizonDir ? 'down' : swipeDirection;
    return /*#__PURE__*/ jsx(Drawer.Root, {
        snapPoints: snapPoints,
        modal: modal,
        disablePointerDismissal: disablePointerDismissal,
        swipeDirection: effectiveSwipeDirection,
        ...props
    });
}
export { DrawerRoot };
